<ng-container
  *ngIf="(educationalPage.content$ | ngrxPush) || emptyContent as content"
>
  <idp-educational-content-page
    [content]="content"
    [shape]="{
      verticalRectangle: {
        display: true,
        count: 1
      }
    }"
    [skeletonMetaData]="{
      loaded: content.loaded,
      error: content.error,
      disabled: content.disabled
    }"
    (action)="redirect($event)"
    auraSkeletonLoader
  ></idp-educational-content-page>
</ng-container>
